import { useTranslation } from "react-i18next";
import { LineChart } from "./charts/LineChart.js";

function transformDataForGraph(inputData) {
  return inputData.map((item) => [
    item._time,
    item.filling_level,
    item.image_url,
  ]);
}

function transformDataForCompactGraph(inputData) {
  return inputData
    .map((item, idx) => {
      if (idx !== 0 && item.packmat) {
        return {
          name: "Compaction",
          value: `${item.diff_filling}%`,
          xAxis: new Date(inputData[idx]._time)?.getTime(),
          yAxis: 100,
          time: inputData[idx]._time,
        };
      }
      return null;
    })
    .filter((item) => item !== null && item !== undefined);
}

const ActivityLevelChart = ({
  container,
  historyCycle,
  findHistoryId,
  showPackmat = true,
  showLimitFillingLevel = true,
  showToolbox = false,
  enableHudInteraction = false,
  selectedReadingTime = null,
}) => {
  const { t } = useTranslation();

  if (!historyCycle?.length) {
    return null;
  }

  return (
    <div
      style={{
        marginLeft: "20px",
        marginRight: "20px",
        marginBottom: "20px",
        marginTop: "20px",
      }}
    >
      <LineChart
        chartName="weight"
        dataChart={transformDataForGraph(historyCycle)}
        dataCompact={transformDataForCompactGraph(historyCycle)}
        unitValueChart="%"
        maxYAxis={100}
        messageLabelTooltip={t("Level")}
        stepYAxis={20}
        dataForCompactOverlay={historyCycle}
        limitFillingLevel={container?.limitFillingLevel}
        container={container}
        historyCurrent={historyCycle}
        findHistoryId={findHistoryId}
        showPackmat={showPackmat}
        showLimitFillingLevel={showLimitFillingLevel}
        showToolbox={showToolbox}
        showTitle={false}
        chartHeightDivisor={2.8}
        enableHudInteraction={enableHudInteraction}
        selectedReadingTime={selectedReadingTime}
      />
    </div>
  );
};

export default ActivityLevelChart;
